import axios from 'axios';

export const API_URL =
  process.env.NODE_ENV == 'production'
    ? process.env.VUE_APP_STRAPI_API_URL
    : 'http://localhost:1338';

const backend = axios.create({
  baseURL: API_URL,
});

const strapi = {
  async authenticateUser(credentials) {
    console.log(credentials.email, credentials.password);
    const res = await backend
      .post('/auth/local', {
        identifier: credentials.email,
        password: credentials.password,
      })
      .then((response) => {
        const user = response.data.user;
        const token = response.data.jwt;
        const res = { user, token };

        return res;
      })
      .catch((e) => {
        console.log('error in strapi: ', e.response);
      });

    return res;
  },
  async registerUser(credentials) {
    // console.log(credentials.email, credentials.password);
    const res = await backend
      .post('/auth/local/register', {
        email: credentials.email,
        password: credentials.password,
        username: credentials.name,
      })
      .then((response) => {
        const user = response.data.user;
        const res = { user };
        return res;
      })
      .catch((e) => {
        console.log('error in strapi:', e.response);
      });
    return res;
  },
  async getAllCourses() {
    const data = await backend.get('/courses').then((response) => {
      return response.data;
    });

    return data;
  },
  async getUsersCourses() {
    const token = localStorage.getItem('token')
      ? localStorage.getItem('token')
      : null;
    const data = await backend
      .get('/usersCourses', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        //console.log('error getUsersCourses response', response);
        return response.data;
      });

    return data;
  },
  async update(course) {
    const token = localStorage.getItem('token')
      ? localStorage.getItem('token')
      : null;

    var axios = require('axios');

    var config = {
      method: 'put',
      url: `${API_URL}` + '/courses/' + `${course.id}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: course,
    };

    const res = await axios(config)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });

    return res;
  },
  async delete(course) {
    const token = localStorage.getItem('token')
      ? localStorage.getItem('token')
      : null;

    var axios = require('axios');

    var config = {
      method: 'delete',
      url: `${API_URL}` + '/courses/' + `${course.id}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: course,
    };

    const res = await axios(config)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });

    return res;
  },
  async create(course) {
    const token = localStorage.getItem('token')
      ? localStorage.getItem('token')
      : null;

    var axios = require('axios');

    var config = {
      method: 'post',
      url: `${API_URL}` + '/courses',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: course,
    };

    const res = await axios(config)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });

    return res;
  },
  async createPDF(newPDF) {
    const token = localStorage.getItem('token')
      ? localStorage.getItem('token')
      : null;

    var axios = require('axios');
    console.log('strapi.js createPDF newPDF', newPDF);
    var config = {
      method: 'post',
      url: `${API_URL}` + '/pdf-uploads',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: newPDF,
    };

    alert('File uploaded and PDF entry created successfully!');

    const res = await axios(config)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });

    return res;
  },
  async emailSend() {
    try {
      const send = await strapi.plugins['email'].services.email.send({
        to: 'demo@olymp.services',
        from: 'demo@olymp.services',
        replyTo: 'demo@olymp.services',
        subject: 'Use strapi email provider successfully',
        text: 'Hello world!',
        html: 'Hello world!',
      });
      console.log('send', send);
    } catch (err) {
      console.log('Exception', err);
    }
  },
  // async newMedia(media) {
  //   const token = localStorage.getItem("token")
  //     ? localStorage.getItem("token")
  //     : null;

  //   var axios = require("axios");

  //   console.log("media in frontend strapi", media);

  //   // let fd = new FormData();
  //   // fd.append("file", media);
  //   // console.log("fd", fd);

  //   var config = {
  //     method: "post",
  //     headers: {
  //       // "Content-Type":
  //       //   "multipart/form-data; boundary=--------------------------195020869066109384024894",
  //       Authorization: `Bearer ${token}`,
  //     },
  //     data: media,
  //   };

  //   const res = await axios(`${API_URL}` + "/newMedia", config)
  //     .then(function (response) {
  //       return response.data;
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });

  //   console.log("res in strapi frontend", res);
  // },
};

export default strapi;
